// src/components/common/aia/tours/adminTours.js
export const adminTours = [
    {
        id: 'admin-welcome-tour',
        title: 'Welcome to Admin Portal',
        role: 'admin',
        autoStart: true,
        steps: [
            {
                target: null,
                title: 'Welcome to Admin Portal! 🎯',
                content: "Welcome to the command center of OakHR! As an admin, you have full control over your organization's HR operations. Let me give you a comprehensive tour of all the powerful features at your fingertips.",
                position: 'bottom'
            },
            {
                target: '.tour-dashboard',
                title: 'Open Dashboard',
                content: 'You are currently in another module. Click Dashboard in the sidebar to start this guided flow from the correct section.',
                position: 'right',
                requireClickIfMissingTarget: '.tour-admin-dashboard-header'
            },
            {
                target: '.tour-admin-dashboard-header',
                title: 'Admin Dashboard',
                content: 'This is your admin dashboard. It gives a live operational snapshot before you move into setup workflows.',
                position: 'bottom'
            },
            {
                target: '.tour-admin-dashboard-edit-layout',
                title: 'Customize Layout',
                content: 'Use Edit Layout to reorder dashboard widgets based on your team priorities.',
                position: 'left'
            },
            {
                target: '.tour-admin-dashboard-datetime-card',
                title: 'Date and Time',
                content: 'This card keeps the current date and time visible for day-to-day HR operations.',
                position: 'bottom'
            },
            {
                target: '.tour-admin-dashboard-clock-toggle',
                title: 'Clock Format Toggle',
                content: 'Click the time to switch between 12-hour and 24-hour format.',
                position: 'left',
                requireClick: true
            },
            {
                target: '.tour-admin-dashboard-attendance-card',
                title: 'Today\'s Attendance Snapshot',
                content: 'This section shows present, absent, leave, inactive, and work-location insights for today.',
                position: 'bottom'
            },
            {
                target: '.tour-admin-dashboard-attendance-view-details',
                title: 'Attendance Drilldown',
                content: 'Use View Details to open full attendance management when you need deeper analysis.',
                position: 'left'
            },
            {
                target: '.tour-admin-dashboard-personal-tasks',
                title: 'Personal Tasks',
                content: 'Your pending tasks and follow-ups appear here.',
                position: 'top'
            },
            {
                target: '.tour-admin-dashboard-team-tasks',
                title: 'Team Tasks',
                content: 'Use this widget to track and coordinate pending team actions.',
                position: 'top'
            },
            {
                target: '.tour-admin-dashboard-module-grid',
                title: 'Module Shortcuts',
                content: 'This grid gives quick access to all admin modules from one place.',
                position: 'top'
            },
            {
                target: '.tour-dashboard',
                title: 'Back to Dashboard',
                content: 'If you are on a different page, click Dashboard in the sidebar first. Then continue to Vibe selection.',
                position: 'right',
                section: 'vibe',
                requireClickIfMissingTarget: '.tour-admin-dashboard-vibe-section'
            },
            {
                target: '.tour-admin-dashboard-vibe-section',
                title: 'Open Vibe',
                content: 'Now click Vibe to continue after reviewing announcements and celebrations.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-vibe-header',
                title: 'Vibe Overview',
                content: 'This is the Vibe workspace for communication, engagement, and social recognition across the company.',
                position: 'bottom'
            },
            {
                target: '.tour-vibe-filters',
                title: 'Feed Filters',
                content: 'Use filters and refresh controls to switch between company feed, personal posts, and other feed views.',
                position: 'bottom'
            },
            {
                target: '.tour-vibe-create-post',
                title: 'Create Post',
                content: 'Use this composer to share updates, recognitions, and engagement posts.',
                position: 'right'
            },
            {
                target: '.tour-vibe-feed-column',
                title: 'Posts Feed',
                content: 'This feed shows ongoing conversations and updates from your organization.',
                position: 'left'
            },
            {
                target: '.tour-vibe-sidebar-announcements',
                title: 'Announcement Widget',
                content: 'Track key company announcements and important communication in this widget.',
                position: 'left'
            },
            {
                target: '.tour-vibe-sidebar-voice',
                title: 'Voice to HR',
                content: 'Review submitted employee concerns and response status from this section.',
                position: 'left'
            },
            {
                target: '.tour-vibe-sidebar-recognition',
                title: 'Recognition Hub',
                content: 'Recognition data and kudos trends are surfaced here for culture visibility.',
                position: 'left'
            },
            {
                target: '.tour-vibe-sidebar-celebration',
                title: 'Celebration Hub',
                content: 'This panel highlights birthdays, anniversaries, and celebration moments.',
                position: 'left'
            },
            {
                target: '.tour-org-view',
                title: 'Proceed to Org View',
                content: 'Now click Org View in the sidebar to continue with organization structure setup.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-functional-structure-tab',
                title: 'Switch to Functional Structure',
                content: 'Now click Functional Structure. This is where you define legal entities and departments.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-legal-entity-card',
                title: 'Legal Entities',
                content: 'These cards represent your legal entities. If you already have one, confirm the name is correct.',
                position: 'right'
            },
            {
                target: '.tour-add-legal-entity',
                title: 'Add a Legal Entity',
                content: 'If no legal entity exists, create one now (for example, your company name) before proceeding. Legal entities are required to build departments and reporting structure.',
                position: 'right',
                inlinePanel: true,
                requireClickIfMissingTarget: '.tour-legal-entity-existing-card'
            },
            {
                target: '.tour-legal-entity-input',
                title: 'Enter Company Name',
                content: 'Section 1: Enter your company name in this field.',
                position: 'right',
                inlinePanel: true,
                requireTargetValue: true
            },
            {
                target: '.tour-save-legal-entity',
                title: 'Save Legal Entity',
                content: 'Section 2: Click Save to create the legal entity and continue.',
                position: 'right',
                inlinePanel: true,
                requireClick: true,
                requireClickIfMissingTarget: '.tour-legal-entity-existing-card'
            },
            {
                target: '.tour-employees',
                title: 'Employee Management',
                content: 'Click Employees here. This is your complete employee database: add new employees, manage existing ones, handle exits, and maintain employee records. Bulk import is available for onboarding multiple employees at once.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-employee-search',
                title: 'Search Employees',
                content: 'Use search to quickly find employees by name, email, or employee code.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-department-filter',
                title: 'Department Filter',
                content: 'Use this filter to narrow the employee list by department.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-list-filters',
                title: 'Advanced Filters',
                content: 'This panel provides legal entity, reporting manager, and access-level filters for deeper control.',
                position: 'bottom'
            },
            {
                target: '.tour-add-employee-button',
                title: 'Add Employee',
                content: 'Use Add Employee to onboard a new employee with profile, org mapping, and initial access setup.',
                position: 'left'
            },
            {
                target: '.tour-primary-access-column',
                title: 'Primary Access',
                content: 'Primary Access sets the user’s main portal role (Employee, Manager, or Admin) and controls their default module permissions.',
                position: 'bottom'
            },
            {
                target: '.tour-secondary-access-column',
                title: 'Secondary Access',
                content: 'Secondary Access grants an additional role context where applicable, useful for users who need cross-role visibility.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-view-details',
                title: 'Employee Profile',
                content: 'Click the View button on any row to open that employee profile and continue the tour there.',
                position: 'left',
                requireClick: true
            },
            {
                target: '.tour-employee-profile-header',
                title: 'Profile Overview',
                content: 'This is the employee profile workspace. From here you can review personal, job, and employment details.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-tab-about',
                title: 'About Section',
                content: 'About gives a quick summary of the employee, including personal introduction, timeline, and activity context.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-tab-profile',
                title: 'Profile Section',
                content: 'Profile contains personal details like contact info, demographic details, and emergency information.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-tab-job',
                title: 'Job Section',
                content: 'Job captures employment data such as designation, legal entity, department, and reporting hierarchy.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-tab-time',
                title: 'Time Section',
                content: 'Time is where attendance and shift-related configuration and records are managed for this employee.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-tab-documents',
                title: 'Documents Section',
                content: 'Documents stores employment records and uploaded files for this employee profile.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-edit-button',
                title: 'Edit Employee',
                content: 'Use Edit Employee to update profile, job, and employment data.',
                position: 'left'
            },
            {
                target: '.tour-employee-more-options',
                title: 'Employee Actions',
                content: 'More Options includes lifecycle actions like initiate exit, login control, and password reset.',
                position: 'left'
            },
            {
                target: '.tour-attendance',
                title: 'Attendance Management',
                content: 'Click Attendance to open company-wide attendance controls, including overview, holiday setup, leave plans, and regularization.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-attendance-header',
                title: 'Attendance Workspace',
                content: 'This is the central attendance workspace where you track daily attendance and manage attendance operations.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-calendar-toggle',
                title: 'Open Calendar View',
                content: 'Click this calendar icon to open the monthly attendance calendar view.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-attendance-calendar-panel',
                title: 'Calendar View',
                content: 'This monthly calendar summarizes daily attendance counts so you can spot patterns quickly.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-calendar-display-options',
                title: 'Calendar Features',
                content: 'Use display options to show or hide Total, Present, Absent, Leave, Holiday, and Week Off counts in each date cell.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-calendar-month-label',
                title: 'Current Month',
                content: 'This header shows the current month and year for the calendar data.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-calendar-prev-month',
                title: 'Previous Month',
                content: 'Click to switch to the previous month and load that month’s attendance summary.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-attendance-calendar-next-month',
                title: 'Next Month',
                content: 'Click to move forward month-by-month and compare attendance trends.',
                position: 'left',
                requireClick: true
            },
            {
                target: '.tour-attendance-calendar-day-selected',
                title: 'Switch Date',
                content: 'Click a date cell to change the selected day and refresh attendance details below.',
                position: 'top',
                requireClick: true
            },
            {
                target: '.tour-attendance-stats',
                title: 'Attendance Snapshot',
                content: 'These cards show total active employees with present, absent, and leave status for the selected date.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-details-header',
                title: 'Employee Attendance Details',
                content: 'This section is the detailed day view with employee-level attendance records.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-day-navigation',
                title: 'Switch Day Quickly',
                content: 'Use previous, next, and Today controls to move between dates without reopening the calendar.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-status-filters',
                title: 'Quick Status Filters',
                content: 'Use these quick filters to focus on present, absent, leave, inactive, holiday, or week-off employees.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-search',
                title: 'Search Employees',
                content: 'Search by employee name or employee code to find a specific person quickly.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-department-filter',
                title: 'Department Filter',
                content: 'Filter the attendance table by department for team-level review.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-location-filter',
                title: 'Location Filter',
                content: 'Filter by Office or WFH to analyze attendance location patterns.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-status-filter',
                title: 'Status Dropdown Filter',
                content: 'Use this dropdown for precise status filtering inside the table header controls.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-export',
                title: 'Export Attendance',
                content: 'Export the currently selected date attendance data for reporting or payroll reconciliation.',
                position: 'left'
            },
            {
                target: '.tour-attendance-table',
                title: 'Attendance Table',
                content: 'This table contains employee-wise attendance details including department, location, time check, and working hours.',
                position: 'top'
            },
            {
                target: '.tour-attendance-employee-row',
                title: 'Open Employee Time Profile',
                content: 'Click any employee row to open that profile directly in the Time tab for deeper attendance investigation.',
                position: 'top',
                requireClick: true
            },
            {
                target: '.tour-attendance-tab-holidays',
                title: 'Holiday Management Tab',
                content: 'Click Holiday Management to configure company holidays and holiday calendars.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-attendance-tab-leave-plans',
                title: 'Leave Plans Tab',
                content: 'Click Leave Plans to define leave policies and accrual rules linked to attendance behavior.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-attendance-tab-regulate',
                title: 'Regulate Attendance Tab',
                content: 'Click Regulate Attendance to manually add or correct attendance entries when needed.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-attendance-tab-overview',
                title: 'Back To Attendance Overview',
                content: 'Click Attendance Overview to return to daily attendance monitoring.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-approvals',
                title: 'Leave Approvals',
                content: 'Manage all leave requests from employees. Review, approve, or reject leave applications and track team leave balances.',
                position: 'right'
            },
            {
                target: '.tour-payrollrun',
                title: 'Payroll Processing',
                content: 'The heart of HR! Run payroll, generate payslips, manage salary structures, handle taxes and deductions, and ensure everyone gets paid correctly and on time.',
                position: 'right'
            },
            {
                target: '.tour-document-builder',
                title: 'Document Templates',
                content: 'Create and manage document templates like offer letters, experience letters, and payslips. Customize templates with your company branding and automate document generation.',
                position: 'right'
            },
            {
                target: null,
                title: 'You\'re Ready to Go! 🏆',
                content: "Amazing! You've completed the admin tour. You now have access to all the tools you need to manage your organization's HR operations efficiently. Remember, I'm just a click away if you need any help!",
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-onboarding-tour',
        title: 'Onboarding & Offboarding',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: '.tour-onboarding',
                title: 'Employee Onboarding',
                content: 'Streamline new hire onboarding! Create onboarding checklists, assign tasks to new employees, track progress, and ensure smooth transitions for new team members.',
                position: 'right'
            },
            {
                target: '.tour-performance',
                title: 'Performance Management',
                content: 'Track performance reviews, goals, and feedback. Manage review cycles and performance templates for comprehensive employee evaluations.',
                position: 'right'
            }
        ]
    },
    {
        id: 'admin-advanced-tour',
        title: 'Advanced Settings',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: '.tour-analytics-dashboard',
                title: 'Analytics Dashboard',
                content: 'View comprehensive HR analytics and insights. Track key metrics, trends, and data visualizations to make informed decisions.',
                position: 'right'
            },
            {
                target: '.tour-shifts',
                title: 'Shift Management',
                content: 'Configure work shifts and schedules. Set up shift timings, assign employees to shifts, and manage shift changes.',
                position: 'right'
            },
            {
                target: '.tour-team-taskbox',
                title: 'Team Taskbox',
                content: 'Create and assign tasks to employees. Track task progress and manage team workflows efficiently.',
                position: 'right'
            }
        ]
    },
    {
        id: 'admin-attendance-tour',
        title: 'Attendance Management Deep Tour',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: '.tour-attendance',
                title: 'Open Attendance',
                content: 'Click Attendance to begin the deep attendance walkthrough.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-attendance-header',
                title: 'Attendance Workspace',
                content: 'This workspace combines daily attendance tracking with policy and correction tools.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-calendar-toggle',
                title: 'Open Calendar View',
                content: 'Click this calendar icon to open the monthly attendance calendar.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-attendance-calendar-panel',
                title: 'Attendance Overview Calendar',
                content: 'The calendar gives a month-level overview so you can inspect daily attendance behavior.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-calendar-display-options',
                title: 'Calendar Display Features',
                content: 'Toggle metrics like total, present, absent, leave, holiday, and week off for clearer analysis.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-calendar-month-label',
                title: 'Month & Year',
                content: 'This shows the currently loaded month and year.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-calendar-prev-month',
                title: 'Switch To Previous Month',
                content: 'Click here to load the previous month.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-attendance-calendar-next-month',
                title: 'Switch To Next Month',
                content: 'Click here to move to the next month.',
                position: 'left',
                requireClick: true
            },
            {
                target: '.tour-attendance-calendar-day-selected',
                title: 'Switch Date',
                content: 'Click a date cell to set the working date for detailed employee attendance below.',
                position: 'top',
                requireClick: true
            },
            {
                target: '.tour-attendance-stats',
                title: 'Daily Snapshot',
                content: 'These cards summarize total active employees and current attendance status counts.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-details-header',
                title: 'Employee Attendance Details',
                content: 'This section shows detailed attendance records for the selected date.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-day-navigation',
                title: 'Day Navigation',
                content: 'Use previous day, next day, and Today to switch dates quickly.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-status-filters',
                title: 'Quick Filters',
                content: 'Use quick filters for fast focus on present, absent, leave, holiday, and week-off groups.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-search',
                title: 'Search',
                content: 'Search by employee name or code for targeted attendance review.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-department-filter',
                title: 'Department Filter',
                content: 'Narrow the attendance table to one department.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-location-filter',
                title: 'Location Filter',
                content: 'Filter employees by office or WFH attendance location.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-status-filter',
                title: 'Status Filter',
                content: 'Filter by present, absent, leave, holiday, week-off, or inactive status.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-export',
                title: 'Export',
                content: 'Export the selected-date attendance sheet for payroll and audits.',
                position: 'left'
            },
            {
                target: '.tour-attendance-table',
                title: 'Attendance Records',
                content: 'This table is the detailed operational view of daily attendance.',
                position: 'top'
            },
            {
                target: '.tour-attendance-employee-row',
                title: 'Drilldown',
                content: 'Click any row to open that employee profile directly on the Time tab.',
                position: 'top',
                requireClick: true
            },
            {
                target: '.tour-attendance-tab-holidays',
                title: 'Holiday Management',
                content: 'Click Holiday Management to configure holidays that impact attendance outcomes.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-attendance-tab-leave-plans',
                title: 'Leave Plans',
                content: 'Click Leave Plans to define leave policies and entitlement structures.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-attendance-tab-regulate',
                title: 'Regulate Attendance',
                content: 'Click Regulate Attendance to add or correct attendance records manually.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-attendance-tab-overview',
                title: 'Daily Overview',
                content: 'Click Attendance Overview to return to daily monitoring.',
                position: 'bottom',
                requireClick: true
            }
        ]
    },
    {
        id: 'admin-employees-overview-tour',
        title: 'Employees Overview',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: '.tour-employees',
                title: 'Open Employees',
                content: 'Click Employees to open employee management.',
                position: 'right',
                requireClick: true
            },
            {
                target: '.tour-employee-search',
                title: 'Search Employees',
                content: 'Use this search field to quickly find employees by name, email, or employee code.',
                position: 'bottom',
                requireTargetValue: true
            },
            {
                target: '.tour-employee-department-filter',
                title: 'Filter by Department',
                content: 'Use this filter to narrow the list to one department.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-employee-list-filters',
                title: 'List Filters Panel',
                content: 'This panel gives advanced filters for legal entity, manager, and access level.',
                position: 'bottom'
            },
            {
                target: '.tour-employee-view-details',
                title: 'Open Employee Details',
                content: 'Click View Details on any row to open the full employee profile.',
                position: 'left',
                requireClick: true
            }
        ]
    },
    {
        id: 'admin-flow-automation-tour',
        title: 'Flow Automation',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Automate your HR workflows ⚡',
                content: "Flow Automation lets you build no-code workflows — onboarding checklists, approval chains, reminders — that run themselves. Let's take a quick look.",
                position: 'bottom'
            },
            {
                target: '.tour-flows',
                title: 'Open Automations',
                content: 'Click Automations in the sidebar to open the Flow Automation workspace.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-flow-stats'
            },
            {
                target: '.tour-flow-stats',
                title: 'Automation at a glance',
                content: 'These cards show your active workflows, total runs, success rate and average duration — so you always know what your automations are doing.',
                position: 'bottom'
            },
            {
                target: '.tour-flow-create',
                title: 'Build a workflow',
                content: 'Create a custom automation from scratch on the visual canvas — drag in triggers, conditions, approvals and actions, then connect them.',
                position: 'top'
            },
            {
                target: '.tour-flow-templates',
                title: 'Or start from a template',
                content: "Don't start from zero — pick a ready-made template (onboarding, offboarding, leave approval and more) and customise it.",
                position: 'top'
            },
            {
                target: '.tour-flow-tabs',
                title: 'Workflows, chains & history',
                content: 'Use these tabs to manage your workflows, build approval chains, browse templates, and review the run history of every automation.',
                position: 'bottom'
            },
            {
                target: null,
                title: "You're set 🚀",
                content: 'Create your first workflow from a template, activate it, and let OakHR handle the repetitive HR steps for you.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-assets-tour',
        title: 'Asset Management',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Track company assets 💼',
                content: 'Asset Management keeps every laptop, phone and device accounted for — who has what, its condition, and a full history. Quick tour:',
                position: 'bottom'
            },
            {
                target: '.tour-assets',
                title: 'Open Assets',
                content: 'Click Assets in the sidebar to open asset management.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-asset-tabs'
            },
            {
                target: '.tour-asset-stats',
                title: 'Your inventory at a glance',
                content: 'These counters show total assets, how many are assigned, available, or in maintenance. Click any card to jump straight to that filtered list.',
                position: 'bottom'
            },
            {
                target: '.tour-asset-tabs',
                title: 'Register, categories & audit',
                content: 'Switch between the asset register, categories, the maintenance log, and a complete audit trail of every assignment and change.',
                position: 'bottom'
            },
            {
                target: null,
                title: 'Everything tracked 📋',
                content: 'Open the Assets tab to add items and assign them to employees — every change is recorded in the audit trail automatically.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-ai-assistant-tour',
        title: 'AI Assistant',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Meet your AI assistant 🤖',
                content: 'OakHR has a built-in AI copilot. Instead of clicking through menus, just ask it — in plain English — about your live HR data.',
                position: 'bottom'
            },
            {
                target: '.tour-ai-fab',
                title: 'Always one click away',
                content: "This is the assistant. It floats on every screen, bottom-right. Click it any time to open the chat — you can even drag it out of your way.",
                position: 'left'
            },
            {
                target: null,
                title: 'Ask about anything',
                content: "Try things like “what's today's attendance?”, “how many approvals are pending?” or “is this month's payroll ready?” — it reads your real data and answers instantly.",
                position: 'bottom'
            },
            {
                target: null,
                title: 'It can take action too',
                content: 'Beyond answering, it can act — apply leave, regularise attendance, or withhold a salary for a month — always with a confirmation step so nothing happens by surprise.',
                position: 'bottom'
            },
            {
                target: null,
                title: 'Metered, never a surprise',
                content: 'Tool actions use AI credits shown in the chat header, so your usage stays predictable. Open the assistant and try “what can you do?” to get started.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-geo-biometric-tour',
        title: 'Geo & Biometric Attendance',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Trusted attendance 📍',
                content: 'OakHR can verify attendance two ways — GPS geo-fencing for mobile punches, and biometric devices (ZKTeco / eSSL) at the gate. Let me show you both.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance',
                title: 'Open Attendance',
                content: 'Click Attendance in the sidebar to manage geo-location and biometric devices.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-attendance-tab-geo'
            },
            {
                target: '.tour-attendance-tab-geo',
                title: 'Geo Location',
                content: 'Open the Geo Location tab to set up location-based attendance.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-geo-add-location',
                title: 'Draw your office fences',
                content: 'Add an office location with a radius. Employees can then only punch in when they are physically inside that geo-fence.',
                position: 'left'
            },
            {
                target: '.tour-geo-tabs',
                title: 'Live map & history',
                content: 'Switch to Live Map to see today\'s punches on a map, or History to audit where past punches happened.',
                position: 'bottom'
            },
            {
                target: '.tour-attendance-tab-biometrics',
                title: 'Biometric devices',
                content: 'Now open the Biometrics tab to connect your physical attendance devices.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-biometric-add-device',
                title: 'Connect a device',
                content: 'Register a ZKTeco or eSSL device. Punches sync automatically into attendance — no manual import.',
                position: 'left'
            },
            {
                target: '.tour-biometric-tabs',
                title: 'Mapping & punch logs',
                content: 'Use User Mapping to link each device user ID to an employee, and Punch Logs to review every raw punch the device sent.',
                position: 'bottom'
            },
            {
                target: null,
                title: 'Verified, every time ✅',
                content: 'Combine geo-fencing and biometrics for attendance you can trust — accurate, tamper-resistant, and fully audited.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-document-builder-tour',
        title: 'Document Builder',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'HR documents in seconds 📄',
                content: 'Document Builder generates offer letters, appointment letters, experience & relieving letters — with employee details merged in automatically. Quick look:',
                position: 'bottom'
            },
            {
                target: '.tour-document-builder',
                title: 'Open Document Builder',
                content: 'Click Document Builder in the sidebar to open the templates workspace.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-docbuilder-templates'
            },
            {
                target: '.tour-docbuilder-tabs',
                title: 'Templates & generate',
                content: 'These tabs let you manage templates and generate documents. Most letters start from a ready-made template.',
                position: 'bottom'
            },
            {
                target: '.tour-docbuilder-templates',
                title: 'Ready-made templates',
                content: 'Pick a built-in template — offer letter, experience letter, and more. Each one auto-fills merge fields like {{employee.name}} and {{designation}}.',
                position: 'top'
            },
            {
                target: '.tour-docbuilder-create',
                title: 'Build your own',
                content: 'Need something custom? Create your own template with the rich editor and your own merge fields.',
                position: 'top'
            },
            {
                target: null,
                title: 'Generate & deliver 📬',
                content: 'Pick a template, select employees, preview, then download the PDF or email it straight to them — letters that used to take an hour now take a minute.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-team-taskbox-tour',
        title: 'Team Taskbox',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Coordinate the team ✅',
                content: 'Team Taskbox is a shared task board for HR work — assign tasks, track progress, and never lose an action item. Quick tour:',
                position: 'bottom'
            },
            {
                target: '.tour-team-taskbox',
                title: 'Open Team Taskbox',
                content: 'Click Team Taskbox in the sidebar to open the team\'s shared tasks.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-taskbox-stats'
            },
            {
                target: '.tour-taskbox-stats',
                title: 'Workload at a glance',
                content: 'These counters show pending, in-progress, under-review, completed and overdue tasks across the team — spot bottlenecks instantly.',
                position: 'bottom'
            },
            {
                target: '.tour-taskbox-create',
                title: 'Assign a task',
                content: 'Create a task, set a priority and due date, and assign it to a team member. They\'ll be notified right away.',
                position: 'left'
            },
            {
                target: '.tour-taskbox-filters',
                title: 'Find anything fast',
                content: 'Search and filter by status or priority to focus on what matters right now.',
                position: 'bottom'
            },
            {
                target: '.tour-taskbox-views',
                title: 'Your way to work',
                content: 'Switch between grid, list, kanban board, calendar and dashboard views — whichever fits how your team works.',
                position: 'left'
            },
            {
                target: null,
                title: 'Nothing slips 🎯',
                content: 'Assign, track and close out team work in one place — with overdue tasks surfaced before they become a problem.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-compensation-tour',
        title: 'Compensation & Statutory',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Salaries & statutory, sorted 💰',
                content: 'The Compensation section is where you define salary structures and handle Indian statutory deductions — Provident Fund and TDS. Quick tour:',
                position: 'bottom'
            },
            {
                target: '.tour-payroll',
                title: 'Open Compensation',
                content: 'Click Compensation in the sidebar to manage salaries, pay groups, PF and TDS.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-comp-tabs'
            },
            {
                target: '.tour-comp-tabs',
                title: 'Four areas, one place',
                content: 'Employee Compensation, Pay Groups, PF Management and TDS Management — all under one roof.',
                position: 'bottom'
            },
            {
                target: '.tour-comp-stats',
                title: 'Salary structures & CTC',
                content: 'See total employees, total and average CTC at a glance, then drill into any employee to set their earnings and deductions.',
                position: 'bottom'
            },
            {
                target: '.tour-comp-tab-pf',
                title: 'Provident Fund',
                content: 'Open PF Management to configure EPF/EPS rules, wage ceilings and exemptions.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-comp-pf',
                title: 'Configure PF your way',
                content: 'Set contribution rates, the wage ceiling and per-employee exemptions — payroll then computes PF automatically every month.',
                position: 'top'
            },
            {
                target: '.tour-comp-tab-tds',
                title: 'Tax Deducted at Source',
                content: 'Now open TDS Management to handle income-tax deductions.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-comp-tds',
                title: 'TDS on autopilot',
                content: 'Set the regime and declarations; payroll calculates each employee\'s monthly TDS based on their annual earnings.',
                position: 'top'
            },
            {
                target: null,
                title: 'Compliant by default ✅',
                content: 'Define pay once and OakHR applies the right PF, Professional Tax and TDS every payroll run — no spreadsheets, no missed slabs.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-payroll-run-tour',
        title: 'Payroll Run & Payslips',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Run payroll with confidence 🧾',
                content: 'Payroll Run computes everyone\'s salary for the month — earnings, PF, Professional Tax, TDS, salary holds — then generates payslips. Let me show you.',
                position: 'bottom'
            },
            {
                target: '.tour-payrollrun',
                title: 'Open Payroll',
                content: 'Click Payroll in the sidebar to start a payroll run.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-payrollhub-tab-run'
            },
            {
                target: '.tour-payrollhub-tab-run',
                title: 'Go to Payroll Run',
                content: 'Open the Payroll Run tab to process the current month.',
                position: 'bottom',
                requireClick: true
            },
            {
                target: '.tour-payroll-period',
                title: 'Pick the month',
                content: 'Choose the payroll period here. OakHR pulls attendance, leave and LOP for that month automatically.',
                position: 'bottom'
            },
            {
                target: '.tour-payroll-detailed',
                title: 'Check every rupee',
                content: 'Open Detailed Calculation to review each employee\'s earnings and deductions before you commit — and spot anyone whose salary is on hold for the month.',
                position: 'top'
            },
            {
                target: null,
                title: 'Process, then payslips 📩',
                content: 'Once validated, Process Payroll, then View Payslips to generate and send them. Need to fix one person? Regenerate just their payslip from the employee\'s Compensation tab — no full re-run.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-billing-tour',
        title: 'Plans & Billing',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Simple, predictable pricing 💳',
                content: "OakHR keeps billing simple — one Pro plan, priced per employee. You'll find Billing under your profile menu (top-right). Here's what it offers:",
                position: 'bottom'
            },
            {
                target: '.tour-billing-plan',
                title: 'One plan, everything included',
                content: 'The Pro plan unlocks every module — attendance, payroll, performance, documents, automations and the AI assistant. No feature gates to puzzle over.',
                position: 'bottom'
            },
            {
                target: '.tour-billing-count',
                title: 'Pay for your team size',
                content: 'Set how many employees you have — pricing scales per seat, so you only pay for what you use.',
                position: 'top'
            },
            {
                target: '.tour-billing-highlights',
                title: 'Seats, AI credits & billing',
                content: 'Your plan includes a monthly pool of AI assistant credits, shown here alongside your seat count and billing cycle.',
                position: 'top'
            },
            {
                target: '.tour-billing-subscribe',
                title: 'Subscribe in one click',
                content: 'Pay securely via Razorpay and you\'re live instantly — cancel any time. Trial users can subscribe right here to lift the 2-employee limit.',
                position: 'top'
            },
            {
                target: null,
                title: 'No surprises 🎉',
                content: 'One plan, per-seat pricing, metered AI credits — billing you can reason about. Open Billing from your profile menu whenever you need it.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-onboarding-review-tour',
        title: 'Onboarding Review',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Smooth new-hire onboarding 🚀',
                content: 'New hires complete a guided wizard; you review and approve what they submit. Here\'s how the admin side works:',
                position: 'bottom'
            },
            {
                target: '.tour-onboarding',
                title: 'Open Onboarding',
                content: 'Click Onboarding in the sidebar to manage new-hire submissions.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-onboarding-tabs'
            },
            {
                target: '.tour-onboarding-tabs',
                title: 'Pending, Completed, All & Configure',
                content: 'Pending shows hires waiting on you, Completed and All give the full picture, and Configure controls the checklist itself.',
                position: 'bottom'
            },
            {
                target: '.tour-onboarding-summary',
                title: 'Where everyone stands',
                content: 'See at a glance how many hires are ready for review, in progress, or done — so nobody stalls.',
                position: 'bottom'
            },
            {
                target: null,
                title: 'Review & decide',
                content: 'Open any pending hire to see their details and documents, then Approve — or Request Changes with a note to send it back for fixes.',
                position: 'bottom'
            },
            {
                target: null,
                title: 'Tune the checklist ⚙️',
                content: 'Use the Configure tab to mark each onboarding item Required, Optional or Hidden — shaping exactly what new hires must provide.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-performance-tour',
        title: 'Performance Reviews',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Run performance reviews 📈',
                content: 'Build review templates, run review cycles, confirm ratings and track trends — all in the Performance module. Quick tour:',
                position: 'bottom'
            },
            {
                target: '.tour-performance',
                title: 'Open Performance',
                content: 'Click Performance in the sidebar to manage reviews.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-performance-tabs'
            },
            {
                target: '.tour-performance-tabs',
                title: 'Pending, Confirmed, Templates & Analytics',
                content: 'Work through pending reviews, browse confirmed ones, manage templates, and see company-wide analytics.',
                position: 'bottom'
            },
            {
                target: '.tour-performance-pending-list',
                title: 'Reviews waiting on you',
                content: 'Pending reviews show up here. Open one to rate the employee against your template and submit.',
                position: 'top'
            },
            {
                target: null,
                title: 'Templates & insights',
                content: 'Create reusable review templates with your own competencies, then watch ratings, distribution and trends build up in Analytics.',
                position: 'bottom'
            }
        ]
    },
    {
        id: 'admin-shifts-tour',
        title: 'Shift Management',
        role: 'admin',
        autoStart: false,
        steps: [
            {
                target: null,
                title: 'Define your work shifts 🕐',
                content: 'Shifts let you set up timing patterns — general, night, split — that drive attendance and overtime. Quick look:',
                position: 'bottom'
            },
            {
                target: '.tour-shifts',
                title: 'Open Shifts',
                content: 'Click Shifts in the sidebar to manage shift timings.',
                position: 'right',
                requireClick: true,
                requireClickIfMissingTarget: '.tour-shifts-add'
            },
            {
                target: '.tour-shifts-add',
                title: 'Create a shift',
                content: 'Add a shift with start/end times, grace periods and break rules. Attendance is then judged against the right shift.',
                position: 'left'
            },
            {
                target: '.tour-shifts-list',
                title: 'Your shifts',
                content: 'Every shift you define lives here — edit timings any time, and assign shifts to employees so their attendance and overtime calculate correctly.',
                position: 'top'
            },
            {
                target: null,
                title: 'Time, handled ✅',
                content: 'With shifts in place, OakHR knows everyone\'s expected hours — powering accurate attendance, late marks and overtime across the company.',
                position: 'bottom'
            }
        ]
    }
];

export const getAdminTour = (tourId) => {
    return adminTours.find(tour => tour.id === tourId);
};

export const getAllAdminTours = () => adminTours;
